// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fs-0";